"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const react_device_detect_1 = require("react-device-detect");
function default_1() {
    (0, react_1.useLayoutEffect)(() => {
        const { isNativeApp } = window;
        const { hostname, pathname, search } = window.location;
        const isExternalReferrer = !document.referrer.includes(hostname);
        if (react_device_detect_1.isAndroid && !isNativeApp && isExternalReferrer) {
            window.location.href = `fondee:/${pathname}${search}`;
        }
    }, []);
}
exports.default = default_1;
